// form
import {
    useFormContext,
    Controller,
    ControllerProps,
    FieldValues,
    FieldPath,
} from "react-hook-form";
// @mui
import {
    Radio,
    RadioGroup,
    FormHelperText,
    FormControlLabel,
    RadioGroupProps,
} from "@mui/material";
import React, { ReactNode } from "react";

// ----------------------------------------------------------------------

export default function RHFRadioGroup<
    T extends string | number | undefined | boolean | null,
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
    name,
    options,
    handleChange,
    value,
    ...other
}: {
    name: ControllerProps<TFieldValues, TName>["name"];
    options: { id: T; label: ReactNode }[];
    value: T;
    handleChange: (event: T) => void;
} & RadioGroupProps) {
    const { control } = useFormContext();
    const onChange = (e: React.SyntheticEvent<Element, Event>) => {
        handleChange((e.target as HTMLInputElement).value as T);
    };
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <>
                    <RadioGroup {...field} value={value} row {...other}>
                        {options.map(({ id, label }) => (
                            <FormControlLabel
                                key={id?.toString()}
                                label={label}
                                value={id}
                                onChange={onChange}
                                control={<Radio size="small" />}
                            />
                        ))}
                    </RadioGroup>

                    {!!error && (
                        <FormHelperText error sx={{ px: 2 }}>
                            {error.message}
                        </FormHelperText>
                    )}
                </>
            )}
        />
    );
}
